import { z } from 'zod';

import { size, isString } from '../../../utils/common.util';

export const MaxLengthValidationBlockSchema = z.number().int().positive();
export type MaxLengthValidationBlock = z.infer<
  typeof MaxLengthValidationBlockSchema
>;

type IsMaxLength = (value: unknown, block: MaxLengthValidationBlock) => boolean;
export const isMaxLength: IsMaxLength = (value, block) => {
  if (!isString(value)) {
    return false;
  }

  return size(value) <= block;
};
